import React, { useCallback } from 'react';
import clsx from 'clsx';
import { FilterableSelect, Option } from 'carbon-react/lib/components/select';

import { ChartOfAccountsAccount } from '@futrli-sdk/predict';
import { useIntl } from '@futrli/localisation';

import { TOTALS_CODE } from '../../../../types';
import styles from './non-cash-transfer.scss';

interface NonCashTransferProps {
  accountRows: ChartOfAccountsAccount[];
  nonCashAccountIndex: string;
  onChange: (value: ChartOfAccountsAccount | null) => void;
  predictionContentTouched: boolean;
}

export const NonCashTransfer = ({
  accountRows,
  nonCashAccountIndex,
  onChange,
  predictionContentTouched
}: NonCashTransferProps) => {
  const intl = useIntl();

  const handleAccountChangeCarbon = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const accountIndex = event.target.value;
      const newSelectedAccount = accountRows.find(o => o.code === accountIndex);
      onChange(newSelectedAccount || null);
    },
    [accountRows, onChange]
  );

  return (
    <FilterableSelect
      mt="24px"
      size="large"
      key="account"
      id="account-selector"
      label={intl.formatMessage({
        id: 'predict.choose_balancing_account',
        defaultMessage: 'Choose balancing account'
      })}
      placeholder={intl.formatMessage({
        id: 'predict.start_typing_find_account',
        defaultMessage: 'Start typing to find your account'
      })}
      value={nonCashAccountIndex || ''}
      onChange={handleAccountChangeCarbon}
      mb={0}
      error={predictionContentTouched && !nonCashAccountIndex.length ? true : false}
    >
      {accountRows.map((o: ChartOfAccountsAccount, i: number) => (
        <Option
          key={`${o.code}-${i}`}
          value={o.code}
          text={o.name}
          disabled={o.code === TOTALS_CODE}
          className={clsx({
            [styles.categoryItemCarbon]: o.code === TOTALS_CODE,
            [styles.accountItemCarbon]: o.code !== TOTALS_CODE
          })}
        >
          <div style={{ width: 6 }}></div>
          <div>{o.name}</div>
        </Option>
      ))}
    </FilterableSelect>
  );
};
